import { useQuery } from '@tanstack/react-query';
import { LocationsApi } from '@up2stay/up2promo-api-client';

export type ReplyPromptTemplateRow = {
  id?: string;
  name?: string;
  context?: string;
  tone?: string;
  considerations?: string;
  mustInclude?: string;
};

/** System reply-style templates (Setup → Antworten → Vorlage). */
export function useReplyPromptTemplates(workspaceId: string | undefined) {
  return useQuery({
    queryKey: ['reply-prompt-templates', workspaceId],
    queryFn: async (): Promise<ReplyPromptTemplateRow[]> => {
      const res = await LocationsApi.getReplyPromptTemplates({
        path: { workspaceId: workspaceId as string },
      } as never);
      const rows = Array.isArray(res.data) ? res.data : [];
      return rows.map((row) => {
        const item = row as ReplyPromptTemplateRow;
        return {
          id: item.id,
          name: item.name,
          context: item.context,
          tone: item.tone,
          considerations: item.considerations,
          mustInclude: item.mustInclude,
        };
      });
    },
    enabled: !!workspaceId,
    staleTime: 5 * 60 * 1000,
  });
}
